import angular from "angular";
import CKEditorTextarea from "../../RichTextEditor/Editors/CKEditor/CKEditorTextarea";

/**
 * Inline editor component
 */
let editorTextarea = {
    bindings: {
        contentLoaded: '<',
        disabled: '<',
        model: '='
    },
    template: require('./editor-textarea.html')
};

export default angular.module('cms.editor.textarea', [CKEditorTextarea]).component('editorTextarea', editorTextarea).name;



// WEBPACK FOOTER //
// ./src/cmsCore/RichTextEditor/EditorTextarea/EditorTextarea.js